import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Divider} from '~library/atoms/Divider';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';

export const PollChoiceOverlay = (props) => {
  useEffect(() => {
    if (props.open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [props.open]);

  const generateGuestInitials = (guest) => {
    if (guest?.guest_name.indexOf(' ') >= 0) {
      return guest?.guest_name
        .replace(/[^a-zA-Z ]/g, '')
        .split(' ')
        .map((word) => word[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
    }
    return guest?.guest_name
      .match(/[a-zA-Z]/)
      .pop()
      .toUpperCase();
  };

  return (
    <ResponsivePanel portalMode showHeader={false} isOpen={props.open} onClose={props.onClose}>
      <div className={`view-invitation__poll-overlay ${props.open ? 'open' : ''}`}>
        <div className="settings-overlay__heading">
          <Typography variant="header5" data-qa-id="settings-header">
            {`${props.choice} (${props.guests.length})`}
          </Typography>
          <button
            data-qa-id="close-poll-overlay"
            className="unstyled-button"
            onClick={props.onClose}
          >
            <CloseLineIcon />
          </button>
        </div>
        <Divider />
        <div className="settings-overlay__section">
          <div className="settings-overlay__poll-list" data-qa-id="poll-overlay-list">
            {props.guests?.map((guest, i) => (
              <div
                key={guest?.guest_name + i}
                className="settings-overlay__poll-list__guest"
                data-qa-id="settings-overlay__poll-list__guest"
              >
                <div className="settings-overlay__poll-list__guest-initials">
                  {generateGuestInitials(guest)}
                </div>
                <Typography
                  variant="paragraph2"
                  classname="settings-overlay__poll-list__guest-name"
                  data-qa-id="settings-overlay__poll-list__guest-name"
                >
                  {guest?.guest_name || ''}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ResponsivePanel>
  );
};

PollChoiceOverlay.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  choice: PropTypes.string,
};
